import React from 'react';
import DS2 from '../../../img/Course-Elements/DS2.png'
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';

const DataScience = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-5xl font-semibold my-4'>Data <span className='text-orange-400'>Science</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>Master Python, Statistics, and Predictive Modeling, the three foundational skills of data science.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why study Data Science?</h1>
                    <h1 className='text-2xl my-2'>Demand has increased by 400%</h1>
                    <p>The need for Data Scientists has increased dramatically as a result of every organisation placing a significant bet on data science to boost business value.</p>
                    <h1 className='text-2xl my-2'>A lucrative wage</h1>
                    <h3>According to Glassdoor, the typical compensation for data science positions is 10LPA+.
                    </h3>
                    <h1 className='text-2xl my-2'>Love of programming and math</h1>
                    <p>It doesn't get more cutting edge than data science, which combines math, statistics, and programming in a delicious way.</p>
                </div>
                <img className='flex-1' src={DS2} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default DataScience;